/**
 * Shared roster catalog: static seed data + helpers for Firestore rosterPlayers / overrides.
 * When Firestore `rosterPlayers` has docs, those are the live roster; static is fallback + seed source.
 */

import placeholder from '../assets/images/generic-player.png';

export const ROSTER_POSITIONS = [
  'Defense',
  'Forward',
  'Center',
  'Left Wing',
  'Right Wing',
  'Goalie',
];

export const PHOTO_POSITION_PRESETS = [
  'center top',
  'center center',
  'center bottom',
  'center 10%',
  'center 15%',
  'center 20%',
  'center 25%',
  'center 30%',
  'center 40%',
  'center 90%',
  'left center',
  'right center',
  '10% 75%',
];

export const players2013 = [
  { name: 'Alex Smigelski', number: 16, position: 'Defense', photoUrl: require('../assets/players/Alex S.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Alex Smigelski brings fresh energy to the blue line and is ready to make a strong impact as a new Gladiator.' },
  { name: 'Alex Nighbert', number: 24, position: 'Defense', photoUrl: require('../assets/players/Alex.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Alex Nighbert is a mobile defenseman with excellent passing ability and a good shot from the point.' },
  { name: 'Kolton Oppenheim', number: 29, position: 'Defense', photoUrl: require('../assets/players/Kolton.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'My name is Kolton Oppenheim, I can play both offense and defense. I am Jewish. I have 2 siblings and a dog named  Opie.', funFact: 'I once memorized every country in the world, all of the capitals and every flag. Quiz me!' },
  { name: 'Isaac Podach', number: 66, position: 'Defense', photoUrl: require('../assets/players/Isaac.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Isaac is coming into his 4th year of hockey and 1st year of spring season. He has been primarily on defense but is open to playing any position. He looks forward to playing with the Gladiators and learning new skills.', funFact: "Isaac's hidden talent outside of hockey  is yoyo tricks and is currently mastering the DNA." },
  { name: 'Conor Wenzel', number: 5, position: 'Forward', photoUrl: require('../assets/players/Connor_W.jpg'), hasPhotoPermission: true, photoPosition: 'center 15%', bio: 'Conor can play offense and defense with an extreme passion for both.', funFact: 'Conor is the second youngest of a family of 10 kids.' },
  { name: 'Dylan Tseng', number: 8, position: 'Forward', photoUrl: require('../assets/players/Dylan.jpg'), hasPhotoPermission: true, photoPosition: 'center -15%', bio: 'Dylan Tseng is a fun, hardworking player who loves being on the ice. He gives his best effort, keeps improving his skills, and brings a positive attitude to the team.', funFact: '• Started playing hockey at age 9\n• Looks up to Connor Bedard\n• Fan of the Florida Panthers\n• Sometimes plays goalie\n• Lucky number: 8\n• Family is from Taiwan\n• Speaks three languages\n• Loves being silly with friends\n• Very competitive in swimming, soccer, and basketball\n• Dreams of becoming a professional athlete one day' },
  { name: 'Jack VonLehmden', number: 28, position: 'Forward', photoUrl: require('../assets/players/Jack.jpg'), hasPhotoPermission: true, photoPosition: 'center 25%', bio: 'Jack VonLehmden is an exciting addition to our offense, bringing speed and creativity to the attack.' },
  { name: 'Hudson Nyitrai', number: 71, position: 'Forward', photoUrl: require('../assets/players/Hudson.jpg'), hasPhotoPermission: true, photoPosition: 'center 25%', bio: 'Hudson Nyitrai is a hard-nosed forward who plays with grit and determination every shift.' },
  { name: 'Aiden Beier', number: 31, position: 'Goalie', photoUrl: require('../assets/players/Aiden_B.jpg'), hasPhotoPermission: true, photoPosition: '10% 75%', bio: 'I love hockey. My favorite hockey team is the Columbus Blue Jackets and I like fishing and roller coasters.', funFact: "I've been in the Detroit Red Wings locker room." },
  { name: 'Ryle Williams', number: 33, position: 'Goalie', photoUrl: require('../assets/players/Ryle.jpg'), hasPhotoPermission: true, photoPosition: 'right center', bio: 'Ryle Williams is a dedicated and skilled goalie who works hard in practice to perfect his craft.' },
];

export const players2014 = [
  { name: 'Tyler Birkle', number: 2, position: 'Defense', photoUrl: require('../assets/players/tyler_birkle.jpg'), hasPhotoPermission: true, photoPosition: 'center 15%', bio: 'Tyler Birkle is a defensive powerhouse, known for his great skating and shot-blocking ability.' },
  { name: 'Hunter Forkapa', number: 3, position: 'Defense', photoUrl: require('../assets/players/Hunter.jpg'), hasPhotoPermission: true, photoPosition: 'center 20%', bio: 'Hunter Forkapa is a reliable defenseman with a great first pass and defensive awareness.' },
  { name: 'Evan Ziehr', number: 9, position: 'Defense', photoUrl: require('../assets/players/Evan.jpg'), hasPhotoPermission: true, photoPosition: 'center 30%', bio: 'Evan Ziehr is a tough, no-nonsense defenseman who plays with a physical edge.' },
  { name: 'Cam Hayes', number: 36, position: 'Defense', photoUrl: require('../assets/players/Cam.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Cameron Hayes is an excellent two-way defenseman who excels in all situations on the ice.' },
  { name: 'Colin Harte', number: 4, position: 'Defense', photoUrl: require('../assets/players/Colin.jpg'), hasPhotoPermission: true, photoPosition: 'center 40%', bio: 'Colin is a seventh grader at PJHS. He has been playing hockey since he was three years old. He likes to go tubing, go skiing, play pickleball, and play video games.', funFact: 'Colin has won two pickleball tournaments.' },
  { name: 'Declan Toland', number: 18, position: 'Defense', photoUrl: placeholder, hasPhotoPermission: true, photoPosition: 'center center', bio: 'Bio and photo coming soon.', funFact: 'To be provided' },
  { name: 'Quintin Smiddy', number: 28, position: 'Defense', photoUrl: require('../assets/players/Q.jpeg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Quintin "Q" Smiddy is a tough, competitive defensive player who takes pride in protecting his zone, shutting down plays, and being a reliable presence for his team. Known for his quiet work ethic and team first mindset, off ice, Q is just as likely to be found putting in extra reps or helping younger players on the team grow.', funFact: 'Obsessed with 90s video games of all systems!' },
  { name: 'Wyatt Brown', number: 8, position: 'Forward', photoUrl: require('../assets/players/Wyatt.jpg'), hasPhotoPermission: true, photoPosition: 'center 90%', bio: 'Wyatt Brown is a forward with excellent vision and playmaking skills.' },
  { name: 'Braxton Kinkaid', number: 10, position: 'Forward', photoUrl: require('../assets/players/Braxton.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Braxton Kinkaid is a strong forward with an excellent work ethic and an eye for setting up teammates.' },
  { name: 'Grant Glover', number: 13, position: 'Forward', photoUrl: require('../assets/players/Grant.jpg'), hasPhotoPermission: true, photoPosition: 'center 10%', bio: 'Grant Glover is a quick and agile forward with a great nose for the net.' },
  { name: 'Aiden Lenz', number: 15, position: 'Forward', photoUrl: require('../assets/players/Aiden.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Aiden Lenz is a fast and aggressive forward with a knack for scoring goals.' },
  { name: 'Xavier Otting', number: 19, position: 'Forward', photoUrl: require('../assets/players/Xavier.jpg'), hasPhotoPermission: true, photoPosition: 'center 20%', bio: 'Xavier Otting is a dynamic forward known for his speed and ability to create scoring chances.' },
  { name: 'Jaxon Katz', number: 22, position: 'Forward', photoUrl: require('../assets/players/Jaxon_Katz.jpg'), hasPhotoPermission: true, photoPosition: 'center 10%', bio: 'Jaxon Katz is a highly skilled forward, known for his offensive creativity and leadership on the ice.' },
  { name: 'Liam Lyons', number: 57, position: 'Forward', photoUrl: require('../assets/players/Liam.jpg'), hasPhotoPermission: true, photoPosition: 'center 5%', bio: 'Liam is a hockey through and through. He is coachable and a great teammate. He strives to improve his skills on and off the ice.', funFact: 'He super passionate about his hair' },
  { name: 'Coleson Lehman', number: 91, position: 'Left Wing', photoUrl: require('../assets/players/Cole.jpg'), hasPhotoPermission: true, photoPosition: 'center 25%', bio: 'Coleson is a new addition who has a passion for hockey with an ability for spotting open passing lanes and works to position himself for rebound opportunities.', funFact: 'One time I scored two goals in one game so Steve Calevro had to buy me a Panera bread bowl.' },
  { name: 'Vincent Calevro', number: 71, position: 'Center', photoUrl: require('../assets/players/Vinny.jpg'), hasPhotoPermission: true, photoPosition: 'center 25%', bio: 'Vincent Calevro is a quick and agile forward with a keen hockey sense who competes relentlessly and drives the game with skill, edge and unwavering commitment to his team.', funFact: 'Vinny is the proud parent of a baby tortoise named Fridge.' },
  { name: 'Graham Brossia', number: 97, position: 'Forward', photoUrl: require('../assets/players/Graham.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'Great at crashing the net to ensure the garbage is picked up.', funFact: 'Playing golf in the summer and gaming when not playing hockey.' },
  { name: 'Blake Brossia', number: 98, position: 'Forward', photoUrl: require('../assets/players/Blake.jpg'), hasPhotoPermission: true, photoPosition: 'center center', bio: 'An offensive wrecking ball that is excellent at creating chaos in front of the net.', funFact: 'Loves to go fast and enjoys fishing.' },
  { name: 'Jager Dudas', number: 88, position: 'Goalie', photoUrl: require('../assets/players/Jager.jpg'), hasPhotoPermission: true, photoPosition: 'center 40%', bio: 'Jager is starting his 2nd travel season with only playing in NET for a little over a year. He is an Honor Roll student. His favorite NHL team is the Buffalo Sabres. He enjoys rollerblading, 4 wheel riding, camping, and working for his family business', funFact: 'Jager has over 140 chickens and has worn a jersey (football and hockey) everyday for 3.5 years straight!' },
];

export const TEAM_LABELS = {
  '2013': '12U',
  '2014': '14U',
};

export const ROSTER_STATS_CSV_URL =
  'https://docs.google.com/spreadsheets/d/e/2PACX-1vQMrMwD7DwuEBw9MVvCx4yOnHCSmOuxRk_iURfLiIWCRxH5QUdpKQ0d_jxZCMFhTA/pub?gid=1545850254&single=true&output=csv';

const POSITION_SORT = {
  Defense: 0,
  Forward: 1,
  Center: 1,
  'Left Wing': 1,
  'Right Wing': 1,
  Goalie: 2,
};

export function playerSlug(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function overrideDocId(teamId, nameOrSlug) {
  const slug = String(nameOrSlug || '').includes(' ') || /[A-Z]/.test(String(nameOrSlug || ''))
    ? playerSlug(nameOrSlug)
    : playerSlug(nameOrSlug);
  return `${teamId}__${slug}`;
}

export function sortRosterPlayers(list) {
  return [...list].sort((a, b) => {
    const pa = POSITION_SORT[a.position] ?? 1;
    const pb = POSITION_SORT[b.position] ?? 1;
    if (pa !== pb) return pa - pb;
    const na = Number(a.number) || 0;
    const nb = Number(b.number) || 0;
    if (na !== nb) return na - nb;
    return String(a.name || '').localeCompare(String(b.name || ''));
  });
}

export function normalizeRosterPlayer(raw, teamIdFallback) {
  const teamId = String(raw.teamId || teamIdFallback || '').trim();
  const name = String(raw.name || raw.playerName || '').trim();
  const slug = String(raw.playerSlug || playerSlug(name)).trim() || playerSlug(name);
  const resolvedId = raw.id || `${teamId}__${slug}`;
  return {
    id: resolvedId,
    teamId,
    name,
    playerSlug: slug,
    number: Number(raw.number) || 0,
    position: String(raw.position || 'Forward').trim() || 'Forward',
    photoUrl: raw.photoUrl || placeholder,
    hasPhotoPermission: raw.hasPhotoPermission !== false,
    photoPosition: String(raw.photoPosition || 'center center').trim() || 'center center',
    bio: typeof raw.bio === 'string' ? raw.bio : '',
    funFact: typeof raw.funFact === 'string' ? raw.funFact : '',
    sortOrder: Number.isFinite(Number(raw.sortOrder)) ? Number(raw.sortOrder) : Number(raw.number) || 0,
    active: raw.active !== false,
  };
}

export function staticRosterAsDocs() {
  return sortRosterPlayers([
    ...players2014.map((p) => normalizeRosterPlayer({ ...p, teamId: '2014' }, '2014')),
    ...players2013.map((p) => normalizeRosterPlayer({ ...p, teamId: '2013' }, '2013')),
  ]);
}

export function getPlayersForTeam(teamId, allPlayers) {
  const list = Array.isArray(allPlayers) ? allPlayers : staticRosterAsDocs();
  return sortRosterPlayers(list.filter((p) => p.teamId === teamId && p.active !== false));
}

export function findRosterPlayer(teamId, playerName, allPlayers) {
  const list = getPlayersForTeam(teamId, allPlayers);
  const target = String(playerName || '').trim().toLowerCase();
  return list.find((p) => p.name.toLowerCase() === target) || null;
}

export function findRosterPlayerById(id, allPlayers) {
  const list = Array.isArray(allPlayers) ? allPlayers : staticRosterAsDocs();
  return list.find((p) => p.id === id) || null;
}

export function listAllRosterPlayers(allPlayers) {
  const list = Array.isArray(allPlayers) ? allPlayers : staticRosterAsDocs();
  return sortRosterPlayers(list.filter((p) => p.active !== false)).map((p) => ({
    teamId: p.teamId,
    teamLabel: TEAM_LABELS[p.teamId] || p.teamId,
    playerName: p.name,
    number: p.number,
    position: p.position,
    key: p.id || `${p.teamId}__${p.playerSlug || playerSlug(p.name)}`,
    label: `${TEAM_LABELS[p.teamId] || p.teamId} · #${p.number} ${p.name}`,
    photoUrl: p.photoUrl,
    bio: p.bio,
    funFact: p.funFact,
    photoPosition: p.photoPosition,
    hasPhotoPermission: p.hasPhotoPermission,
  }));
}

export function rosterShareUrl(teamId, playerName, origin) {
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : 'https://gcghockey.com');
  const params = new URLSearchParams({
    team: String(teamId),
    player: String(playerName || '').trim(),
  });
  return `${base}/roster?${params.toString()}`;
}

export function mergePlayerWithOverride(player, override) {
  if (!player) return null;
  if (!override) return { ...player };
  const next = { ...player };
  if (typeof override.bio === 'string' && override.bio.trim()) next.bio = override.bio;
  if (typeof override.funFact === 'string') next.funFact = override.funFact;
  if (typeof override.photoUrl === 'string' && override.photoUrl.trim()) {
    next.photoUrl = override.photoUrl;
    next.hasPhotoPermission = true;
  }
  if (typeof override.photoPosition === 'string' && override.photoPosition.trim()) {
    next.photoPosition = override.photoPosition;
  }
  return next;
}

/** Payload for writing/updating a rosterPlayers Firestore doc (slug immutable after create). */
export function rosterPlayerWritePayload(fields, { existingSlug } = {}) {
  const teamId = String(fields.teamId || '').trim();
  const name = String(fields.name || '').trim();
  const slug = existingSlug || playerSlug(name);
  return {
    teamId,
    name,
    playerSlug: slug,
    number: Number(fields.number) || 0,
    position: String(fields.position || 'Forward').trim() || 'Forward',
    bio: String(fields.bio || '').trim(),
    funFact: String(fields.funFact || '').trim(),
    photoUrl: typeof fields.photoUrl === 'string' ? fields.photoUrl : '',
    photoPosition: String(fields.photoPosition || 'center center').trim() || 'center center',
    hasPhotoPermission: fields.hasPhotoPermission !== false,
    sortOrder: Number.isFinite(Number(fields.sortOrder))
      ? Number(fields.sortOrder)
      : Number(fields.number) || 0,
    active: fields.active !== false,
  };
}

export async function shareRosterPlayerLink({ teamId, playerName, title }) {
  const url = rosterShareUrl(teamId, playerName);
  const shareTitle = title || `${playerName} · Glass City Gladiators`;
  const shareText = `Check out ${playerName} on the Glass City Gladiators roster!\n\n${url}`;

  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({
        title: shareTitle,
        text: `Check out ${playerName} on the Glass City Gladiators roster!`,
        url,
      });
      return { ok: true, method: 'share' };
    } catch (e) {
      if (e && e.name === 'AbortError') return { ok: false, method: 'share', aborted: true };
    }
  }

  try {
    await navigator.clipboard.writeText(shareText);
    return { ok: true, method: 'clipboard' };
  } catch {
    return { ok: false, method: 'clipboard' };
  }
}
